import { BASE_ASSETS } from "@assets/templates/constants";
import type { TemplateDefinition } from "@assets/templates/types";

export const wildlifePtarmiganDetectExample: TemplateDefinition = {
  mode: "detect",
  slug: "wildlife-ptarmigan-detect-example",
  version: 1,
  title: "Wildlife observation",
  description: "Find camouflaged animals in landscape",
  subdescription: "Zoom, crop, and inspect to identify fine objects",
  thumbnailUuid: BASE_ASSETS.wildlifePtarmiganExample.uuid,
  assets: [BASE_ASSETS.wildlifePtarmiganExample],
  detect: {
    mediaUuid: BASE_ASSETS.wildlifePtarmiganExample.uuid,
    categories: ["ptarmigan"],
    config: {
      output: "box",
      enableThinking: true,
    },
  },
};
